import { createFileRoute, useRouter } from "@tanstack/react-router";

import { QuestionnaireAgreementConnector } from "@pages/questionnaire-agreement";

export const Route = createFileRoute("/_private/questionnaire-agreement")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();

  const toVerification = () => {
    router.navigate({
      search: {
        tab: "verify",
      },
      to: "/profile",
    });
  };

  return (
    <QuestionnaireAgreementConnector
      onGoBack={toVerification}
      onSuccess={toVerification}
    />
  );
}
